import axiosInstance from "src/common/axiosInstance";

/**
 * Per-user settings kept on the server so the active WhatsApp connection
 * (workspace + account + phone number) and future preferences survive logout
 * and follow the user across devices.
 */
const userSettingsService = {
  get() {
    return axiosInstance.get("/me/settings");
  },

  update(payload) {
    return axiosInstance.put("/me/settings", payload);
  },
};

export default userSettingsService;
